const digest = '2e43a5d6700a674315125202809834125fd1a1ff1df7e17d99d1d88013d0a263';
const css = `._ErrorLayout_1io1u_1 .alert{margin:0 auto}._main_1io1u_5{margin:0 auto;max-width:1000px;padding:10px;width:100%}`;
(function() {
  if ( global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'ErrorLayout': '_ErrorLayout_1io1u_1', 'main': '_main_1io1u_5' };
export const ErrorLayout = '_ErrorLayout_1io1u_1';
export const main = '_main_1io1u_5';
export { css, digest };